import jQuery from 'jquery';
import Core from './../Core/Core';

const errors = {
  871: 'Invalid card number. Check and retry. (Not Mod10)',
  872: 'Invalid card number. Check and retry. (Too short)',
  873: 'Invalid card number. Check and retry. (Too long)',
  874: 'Invalid card number. Check and retry. (Not a number)',
  875: 'We are experiencing technical difficulties. Please try again later or call 555-555-1212',
  876: 'Invalid card number. Check and retry. (Failure from Server)',
  881: 'Invalid card validation code. Check and retry. (Not a number)',
  882: 'Invalid card validation code. Check and retry. (Too short)',
  883: 'Invalid card validation code. Check and retry. (Too long)'
};

// Vantiv library is lame and requires jQuery on the window
window.jQuery = jQuery;

export default function eProtectClient(options) {
  let my = {};

  function init(options) {
    if (!options) {
      throw 'Options must be provided';
    }

    if (!options.litleClient) {
      throw 'Litle client must be provided';
    }

    my.litle = options.litleClient;

    return my;
  }

  /**
   * Accepts a credit card number and a cvv and sends them off to Litle for
   * handling. This generates a PayPageRegistrationId that can then later be
   * exchanged for a chargeable token.
   *
   * @param {string} orderId A unique identifier for this order
   * @param {string} cc Credit card number to generate a registration id for
   * @param {string} cvv CVV of the card to generate a registration id for
   * @returns {Promise<any>}
   */
  my.requestPayPageRegistrationId = function requestPayPageRegistrationId(orderId, cc, cvv) {

    // Generate temporary fields to satisfy the Litle Client
    let ccIn = document.createElement('input');
    let cvvIn = document.createElement('input');
    let ppIdOut = document.createElement('input');
    let binOut = document.createElement('input');

    // Clear out values as we can not be confident elements will get gc'd
    function cleanup() {
      ccIn.value = '';
      cvvIn.value = '';
      ppIdOut.value = '';
      binOut.value = '';
    }

    ccIn.value = cc;
    cvvIn.value = cvv;

    let req = {
      paypageId: Core.config.eProtect && Core.config.eProtect.payPageId,
      reportGroup: 'ecommerce',
      orderId: orderId,
      id: orderId,
      url: Core.config.eProtect && Core.config.eProtect.url
    };

    let fields = {
      accountNum: ccIn,
      cvv2: cvvIn,
      paypageRegistrationId: ppIdOut,
      bin: binOut
    };

    return new Promise(function(resolve, reject) {
      my.litle.sendToLitle(
        req,
        fields,
        function success(response) {
          cleanup();
          resolve({
            paypageRegistrationId: response.paypageRegistrationId,
            type: response.type
          });
        },
        function error(response) {
          let err = response.message;
          let errorNum = parseInt(response.response);

          if (errors[errorNum] !== undefined) {
            err = errors[errorNum];
          }

          cleanup();
          reject(err);
        },
        function timeout() {
          cleanup();
          reject('Litle request timed out')
        },
        15000
      );
    });
  };

  return init(options);
}